<template>
  <v-card class="stat-card" :class="{ 'stat-card--clickable': clickable, 'stat-card--alert': alert }" :loading="loading"
    @click="clickable ? $emit('click') : null">
    <div class="stat-card__top">
      <v-icon v-if="icon" size="18" color="primary">{{ icon }}</v-icon>
      <small class="stat-card__label" :title="label">{{ label }}</small>
      <v-tooltip v-if="info" bottom max-width="280">
        <template v-slot:activator="{ on, attrs }">
          <v-icon size="16" color="#9aa4b5" class="stat-card__info" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span>{{ info }}</span>
      </v-tooltip>
    </div>
    <strong class="stat-card__value" :style="color ? { color } : null"><slot>{{ value }}</slot></strong>
    <span v-if="hint" class="stat-card__hint">{{ hint }}</span>
  </v-card>
</template>

<script>
// Cartão de indicador padrão das telas (rótulo, valor e dica)
export default {
  name: 'StatCard',

  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    hint: { type: String, default: '' },
    info: { type: String, default: '' },
    icon: { type: String, default: '' },
    color: { type: String, default: '' },
    clickable: { type: Boolean, default: false },
    alert: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  }
}
</script>
